<template>
  <Legacy
    view="tools"
    action="trackinglog"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      breadcrumb: {
        name: 'Tracking Error Log',
        route: { name: 'configuration-tracking-error-log' }
      },
      indexes: []
    }
  }
}
</script>
